module.exports = __webpack_public_path__ + "img/extended.d9b5210f.png";